@if (visible()) {
  <div class="add-script-card">
    <div class="head">
      <img src="assets/icons/my-scripts-add.svg" />
      <ion-icon (click)="hide()" icon="close-outline" />
    </div>
    <div class="title">All your scripts in one safe place</div>
    <div class="sub-title">Staying on top of your scripts is now easier than ever.</div>
    <app-button label="Add eScript" bgColor="primary" (click)="addScript()" />
  </div>
}